module.exports = "/_next/static/images/7bba1a847ec91e1fa2741a1d2549a1fb-blog2-lg.png.webp";